import React from "react"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from "react-accessible-accordion"
import "react-accessible-accordion/dist/fancy-example.css"
import BlockContent from "../blockContent"

export default function FaqSegment({ segment }) {
  return (
    <div className="segment faqSegment" style={{ backgroundColor: segment.segstyle?.bg.value, marginBottom: "50px" }}>

      <div className="container">
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-lg-12 col-md-12">
              <div className="faq-accordion">
                <h2>{segment.title}</h2>

                <Accordion allowZeroExpanded={true}>
                  {segment.faqs.map((faq) => (
                    <AccordionItem key={faq._key}>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          {faq.question}
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>
                        <BlockContent blocks={faq.answer} />
                      </AccordionItemPanel>
                    </AccordionItem>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}